module.exports = "<div class=\"deconnection-dialog\">\r\n  <h2>{{data.messageType | translate}}</h2>\r\n  <div>\r\n    <p>{{data.message | translate}}</p>\r\n  </div>\r\n  <button mat-button mat-raised-button color=\"primary\" type=\"reset\" (click)=\"dialogRef.close(null)\">\r\n    {{ data.button | translate }}\r\n  </button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/profile/edition/dialog/error-dialog.component.html
// module id = ../../../../../src/app/profile/edition/dialog/error-dialog.component.html
// module chunks = main